import { Box } from "@mui/material";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LeftArrowIcon, LogoShapeIconGreen, LogoTextIconGreen } from "../../../assets/icons";
import theme, { getTenant } from "../../../theme";

export default function Type2({ historyBack }: { historyBack?: boolean }) {
  const navigate = useNavigate();
  const tenant = getTenant();
  useEffect(() => {
    document.body.style.backgroundColor = theme.palette.text.white;
  }, []);
  return (
    <Box className="mobile-header type2" sx={{ height: "60px", display: "flex", alignItems: "center" }}>
      <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
        {historyBack ? (
          <Box
            onClick={() => navigate(-1)}
            sx={{
              color: "text.fontDark",
              display: "flex",
              position: "absolute",
              insetInlineStart: "0",
              top: "7px",
              padding: "12px",
            }}
          >
            <LeftArrowIcon width={24} height={24} />
          </Box>
        ) : null}
        <Link to={"/"} style={{ display: "flex", gap: "8px", justifyContent: "center", width: "100%" }}>
          <Box
            sx={{
              backgroundImage: `url(../../${tenant.name}/logoHorizontal.svg)`,
              height: `35px`,
              width: `100%`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "contain",
              backgroundPositionX: `center`,
            }}
          />
        </Link>
      </Box>
    </Box>
  );
}
